import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { bind, showErrorSwal } from '@asamco/utils';
import { DxDataGridComponent, DxTabPanelModule, DxSelectBoxModule, DxDataGridModule, DxTextBoxModule, DxButtonModule } from 'devextreme-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { SettingTemplateGrouping } from '../../../interfaces/link-setting-template-grouping.interface';
import { LinkTemplate } from '../../../interfaces/link-template.interface';
import { AccessLevel, SettingTemplate } from '../../../interfaces/setting-template.interface';
import { LinkTemplateService } from '../../../services/link-template.service';
import { SettingTemplateGroupingService } from '../../../services/setting-template-grouping.service';
import { SettingTemplateService } from '../../../services/setting-template.service';
import { DxoSortingModule, DxoEditingModule, DxoSelectionModule, DxoRowDraggingModule, DxoScrollingModule, DxiColumnModule, DxoLookupModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { NgIf, AsyncPipe } from '@angular/common';
import { LinkInformationSettingBlacklistComponent } from './link-information-setting-blacklist/link-information-setting-blacklist.component';

@Component({
  selector: 'app-shell-link-edit-setting-grouping-admin',
  templateUrl: './link-edit-setting-grouping-admin.component.html',
  styleUrls: ['./link-edit-setting-grouping-admin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, DxTabPanelModule, DxTemplateModule, DxSelectBoxModule, DxDataGridModule, DxoSortingModule, DxoEditingModule, DxoSelectionModule, DxoRowDraggingModule, DxoScrollingModule, DxiColumnModule, DxoLookupModule, FormsModule, ReactiveFormsModule, DxTextBoxModule, DxButtonModule, AsyncPipe, LinkInformationSettingBlacklistComponent]
})
export class LinkEditSettingGroupingAdminComponent implements OnInit {
  @ViewChild('linksettinggroupinggrid', { static: false }) grid: DxDataGridComponent;

  title: string = "Admin manage settings and setting groups";
  public showSubject = new BehaviorSubject<boolean>(false);
  public linkSettings: SettingTemplate[] = [];
  public linkGroupSettings: SettingTemplateGrouping[] = [];

  public linkTemplate$: Observable<LinkTemplate[]>;
  //public settingTemplateGroupings$: BehaviorSubject<SettingTemplateGrouping[]> = new BehaviorSubject<SettingTemplateGrouping[]>(undefined);

  public settingTemplateSubject: BehaviorSubject<SettingTemplate[]> = new BehaviorSubject<SettingTemplate[]>(undefined);
  public selectedLinkTemplateId: BehaviorSubject<number> = new BehaviorSubject<number>(undefined);

  public popupVisibleSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public groupManagementDataGridDisabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public settingTemplateDataGridDisabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public selectedTab: number = 0;

  listOfTabs: any[] = [
    {
      ID: 1,
      TabName: 'Setting configuration'
    },
    {
      ID: 2,
      TabName: 'Settings grouping configuration'
    },
    {
      ID: 3,
      TabName: 'Link information setting blacklisting'
    }
  ]

  listOfAccessLevels: any[] = [
    {
      id: AccessLevel.normal,
      name: AccessLevel[AccessLevel.normal]
    },
    {
      id: AccessLevel.advanced,
      name: AccessLevel[AccessLevel.advanced]
    },
    {
      id: AccessLevel.Hidden,
      name: AccessLevel[AccessLevel.Hidden]
    },
    {
      id: AccessLevel.superadmin,
      name: AccessLevel[AccessLevel.superadmin]
    }
  ]


  contactForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
  });

  createButtonOptions: any;

  cancelButtonOptions: any;

  events: Array<string> = [];

  constructor(private cdr: ChangeDetectorRef, private linkTemplateService: LinkTemplateService, private settingsTemplateService: SettingTemplateService, private settingTemplateGroupingService: SettingTemplateGroupingService) {
  }

  public get accessLevel(): typeof AccessLevel {
    return AccessLevel;
  }
  ngOnInit(): void {
  }

  attemptToDelete(e) {
    console.log(e)
    this.settingTemplateGroupingService.deleteLinkSettingGroup(e.data.id).subscribe(item => {
      this.grid.instance.deleteRow(e.row.rowIndex)
    }, error => {
      showErrorSwal(error)
    })

  }

  setupModal() {
    this.linkTemplate$ = this.linkTemplateService.getAllLinkTemplates();
    this.settingTemplateGroupingService.getAllLinkSettingGroupings().subscribe(result => this.linkGroupSettings = result);



    //this.linkSettings = linkSettings;
    //this.linkSettingsSubject.next(linkSettings);
    this.showSubject.next(true);
  }

  @bind
  updateSettingTemplateField(e) {
    this.settingTemplateDataGridDisabled.next(true);
    this.settingsTemplateService.updateSingleSettingTemplate(e.data).subscribe(e => {
      this.settingTemplateDataGridDisabled.next(false);
    }, error => {
      this.settingTemplateDataGridDisabled.next(false);
      showErrorSwal(error)
    })
  }

  createNewGroup() {
    this.settingTemplateGroupingService.createLinkSettingGroup(<any>this.contactForm.value).subscribe(e => {
      Swal.fire({ text: "Succesfully created new group" })
      this.settingTemplateGroupingService.getAllLinkSettingGroupings().subscribe(result => {
        this.linkGroupSettings = result
        this.cdr.detectChanges();
      });
    }, error => {
      showErrorSwal(error);
    })
  }

  addNewGroup() {
    this.popupVisibleSubject.next(true);
  }

  onValueChanged(e) {
    this.selectedLinkTemplateId.next(e.value);
    this.settingsTemplateService.getSettingTemplateByLinkTemplateId(e.value).subscribe(e => {
      this.linkSettings = e;
      this.cdr.detectChanges();
    })
  }

  @bind
  onAdd(e) {
    // var objIndex = this.linkSettings.findIndex(item => item.id == e.itemData.id);
    // this.linkSettings[objIndex].groupName = e.toData;
    e.itemData.groupName = e.toData;
    this.linkSettings = [...this.linkSettings]
    this.cdr.markForCheck();
  }

  @bind
  onReorderGroupSettings(e) {
    // Retrieve visible rows and sort linkGroupSettings by index.
    let visibleRows = e.component.getVisibleRows();
    this.linkGroupSettings.sort((a, b) => a.index - b.index);

    // Find the positions to move from and to within linkGroupSettings.
    const toIndex = this.linkGroupSettings.indexOf(visibleRows[e.toIndex].data);
    const fromIndex = this.linkGroupSettings.indexOf(e.itemData);

    // Remove the item from its original position and insert it at the new position.
    const [movedItem] = this.linkGroupSettings.splice(fromIndex, 1);
    this.linkGroupSettings.splice(toIndex, 0, movedItem);

    // Reassign unique, sequential indices to all items in linkGroupSettings.
    this.linkGroupSettings.forEach((item, index) => {
      item.index = index + 1;
    });

    // Trigger Angular's change detection to reflect changes.
    this.cdr.markForCheck();
  }

  @bind
  onReorder(e) {
    // Get visible rows and sort linkSettings by sortingIndex
    let visibleRows = e.component.getVisibleRows();
    this.linkSettings.sort((a, b) => a.sortingIndex - b.sortingIndex);

    // Find the positions to move the item within linkSettings
    const toIndex = this.linkSettings.indexOf(visibleRows[e.toIndex].data);
    const fromIndex = this.linkSettings.indexOf(e.itemData);

    // Remove the item from its original position and insert it at the new position
    const [movedItem] = this.linkSettings.splice(fromIndex, 1);
    this.linkSettings.splice(toIndex, 0, movedItem);

    // Reassign unique, sequential sortingIndex values to all items in linkSettings
    this.linkSettings.forEach((item, index) => {
      item.sortingIndex = index + 1;
    });

    // Trigger Angular's change detection to reflect changes
    this.cdr.markForCheck();
  }

  @bind
  setCellValueEdit(rowData: any, value: any, more: any): void {

    //rowData.CityID = null;
    let newSettingTemplate: SettingTemplateGrouping = { id: more.id, index: more.index, name: value }
    rowData.name = value;
    this.groupManagementDataGridDisabled.next(true);
    this.settingTemplateGroupingService.updateSingleSettingTemplateGrouping(newSettingTemplate).subscribe(e => {
      this.groupManagementDataGridDisabled.next(false);
      //(<any> this).defaultSetCellValue(rowData, value);
    },
      error => {
        //Ugly hack, resets the user to the first tab if we fail to update ()
        this.settingTemplateGroupingService.getAllLinkSettingGroupings().subscribe(result => this.linkGroupSettings = result);
        this.groupManagementDataGridDisabled.next(false);
        this.cdr.markForCheck();
        this.selectedTab = 0;
        showErrorSwal(error)
      })
  }

  save() {
    this.settingsTemplateService.updateSettingTemplateIndexAndGrouping(this.linkSettings).subscribe(e => {
      Swal.fire({ icon: 'success', text: "Successfully updated settings" })
    }, error => {
      showErrorSwal(error);
    })
  }

  saveGroupSettings() {
    this.settingTemplateGroupingService.updateSettingTemplateGroupIndex(this.linkGroupSettings).subscribe(e => {
      Swal.fire({ icon: 'success', text: "Successfully updated indexes" })
    }, error => {
      showErrorSwal(error);
    })
  }

  cancel() {
    this.showSubject.next(false)
  }

}
